import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';

import { Languages, SUPPORTED_LANGUAGES } from '@/shared/constants';
import { ROUTES } from '@/shared/routes';

const LanguageGuard: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { lang } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const supportedLngs = useMemo(
    () => i18n.options.supportedLngs || SUPPORTED_LANGUAGES,
    [i18n.options.supportedLngs]
  );

  useLayoutEffect(() => {
    if (lang && !supportedLngs.includes(lang)) {
      let newPath = location.pathname.replace(
        new RegExp(`/${lang}`),
        `/${Languages.ru}`
      );

      if (newPath.match(/^\/\w{2}\/?$/)) {
        newPath += `/${ROUTES.leasingScoring}`;
      }
      newPath += location.search;

      window.location.href = newPath;
    } else if (location.pathname.match(/(^\/\w{2}\/?$)|(^\/$)/)) {
      window.location.href = `/${Languages.ru}/${ROUTES.leasingScoring}`;
    } else if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [location, lang, i18n, supportedLngs]);

  // Настройки языка документа для SEO
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return children;
};

export { LanguageGuard };
